'use client';

import { useTranslations } from 'next-intl';
import { BrowserLink } from '@portals/ui-kit';
import { MOBILE_APP_LINK } from '@/_components/mobile-app/_constants';
import { useAnalytics } from '@/_hooks/use-analytics';
import { EAnalytics } from '@/_constants/analytics';

type TProps = {
  text: string;
};

export const ApplicationStoreLink = ({ text }: TProps) => {
  const translations = useTranslations();

  const sendEvent = useAnalytics();

  const handleClick = () => {
    sendEvent({
      name: EAnalytics.SUPPLIER_LANDING_WB_PARTNERS_T,
    });
  };

  return (
    <BrowserLink
      color="blue500"
      onClick={handleClick}
      routeName={MOBILE_APP_LINK}
      size="body-m"
      target="_blank"
      text={translations(text)}
    />
  );
};
